var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkAuth === null
    ? _c("div", [_vm._v(" Loading.. ")])
    : _vm.checkAuth === false
    ? _c("div", [_vm._v(" auth fail ")])
    : _vm.checkAuth === true
    ? _c(
        "div",
        {
          staticClass: "layer",
          attrs: { "data-grm-comp": "SysAdminMain" },
          on: { click: _vm.showComponent },
        },
        [
          _c("System"),
          _c("Room"),
          _c("RoomUser"),
          _c("RoomCall"),
          _c("RoomCallMixer"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }